import React, { useRef, useContext, useState } from 'react';
import { createPopper } from '@popperjs/core';
import './quotes.scss';
import { lang } from '../lang';
import PanelistInfo from '../PanelistInfo/PanelistInfo';
import { WidthContext } from '../../WidthContext';

function Quotes({ data, cl }) {
  const { photo, panelist, c, quotes } = lang.panelists.content[data[0]];
  const logoTooltip = useRef();
  const { viewSize, touch } = useContext(WidthContext);
  const [tooltipVisible, setTooltipVisible] = useState(false);

  const handleMouseEnterLogo = (e) => {
    const content = logoTooltip.current;
    createPopper(e.target, content, {
      placement: viewSize === 'large' ? (cl === 'even' ? 'right' : 'left') : 'bottom',
      modifiers: [
        {
          name: 'offset',
          options: {
            offset: viewSize === 'large' ? [0, 30] : cl === 'even' ? [100, 5] : [-100, 5]
          }
        }
      ]
    });
    content.style.visibility = 'visible';
    setTooltipVisible(true);
  };

  const handleMouseLeaveLogo = () => {
    logoTooltip.current.style.visibility = 'hidden';
    setTooltipVisible(false);
  };

  return (
    <div className={`quotes quotes--${cl}`} onClick={tooltipVisible ? handleMouseLeaveLogo : null}>
      {touch ? (
        <img
          className="quotes__portrait"
          src={photo}
          alt=""
          onClick={(e) => {
            handleMouseEnterLogo(e);
          }}
        />
      ) : (
        <img
          className="quotes__portrait"
          src={photo}
          alt=""
          onMouseEnter={(e) => {
            handleMouseEnterLogo(e);
          }}
          onMouseLeave={handleMouseLeaveLogo}
        />
      )}

      <div className="quotes__tooltip" ref={logoTooltip}>
        <PanelistInfo data={lang.panelists.content[data[0]]} origin={'quotes'} />
      </div>
      <div className="quotes__box">
        <svg
          width="41"
          height="57"
          viewBox="0 0 41 57"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className={`quotes__pointer quotes__pointer--${cl}`}
        >
          <path
            d="M40.5327 52.7889C40.5327 56.7465 35.3998 58.3006 33.2045 55.0077L0.678593 6.21881C-1.09355 3.56059 0.812008 -3.4725e-06 4.00679 -3.1932e-06L36.5327 -3.49692e-07C38.7419 -1.56563e-07 40.5327 1.79086 40.5327 4L40.5327 52.7889Z"
            fill="white"
          />
        </svg>

        <p className="quotes__copy">
          “
          {quotes[data[1]].map((c, i) => {
            return (
              <span key={`quotes-${i}`} className={`quotes__copy--${c[0]}`}>
                {c[1]}
              </span>
            );
          })}
          ”
        </p>
        <div className={`${c} quotes__name`}>— {panelist}</div>
      </div>
    </div>
  );
}

export default Quotes;
